import { Box, Container, Typography } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { Link, Navigate, useLocation } from 'react-router-dom'

import Button from '@/components/button'
import { routes } from '@/routes/config'

import { useStyles } from './styles'

function FinishEdit() {
  const classes = useStyles()

  const location = useLocation()

  if (!location.state) {
    return <Navigate to={routes.Diagnoses()} replace />
  }

  return (
    <Container className={classes.container}>
      <Box>
        <Box>
          <CheckCircleIcon />
          <Typography variant={'h1'} align='center'>
            Dados do diagnóstico <br /> atualizados.
          </Typography>
        </Box>
      </Box>
      <Box>
        <Link to={routes.Diagnoses()}>
          <Button>Ok, finalizar</Button>
        </Link>
      </Box>
    </Container>
  )
}

export default FinishEdit
